/**
 * IMPL-055 (2026-05-26) · Helper compartido para tracking de eventos del funnel.
 *
 * Reutiliza el visitorId/sessionId del PageTracker existente y POST al endpoint
 * `/api/analytics/visit` ya disponible (acepta `eventType` libre).
 *
 * Diseño:
 * - Nunca lanza errores · siempre silencioso (try/catch sin re-throw).
 * - No bloquea UX · `await` opcional pero los callers no esperan respuesta.
 * - Reutiliza localStorage 'mobilsafe_visitor_id' y sessionStorage 'mobilsafe_session_id'
 *   (mismas claves que `PageTracker.jsx` · L9, L27) para asociar todos los eventos
 *   del usuario al mismo visitor.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function getVisitorId() {
  try {
    let v = localStorage.getItem("mobilsafe_visitor_id");
    if (!v) {
      v = "v_" + Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
      localStorage.setItem("mobilsafe_visitor_id", v);
    }
    return v;
  } catch {
    return null;
  }
}

function getSessionId() {
  try {
    let s = sessionStorage.getItem("mobilsafe_session_id");
    if (!s) {
      s = "s_" + Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem("mobilsafe_session_id", s);
    }
    return s;
  } catch {
    return null;
  }
}

/**
 * Registra un evento del funnel.
 * @param {string} page       Página lógica (landing · client_entry · simulator).
 * @param {string} eventType  Evento dentro de la página (entry · cta_analisis · sector_completed · …).
 * @param {object} extraData  Opcional. Campos adicionales aceptados por PageVisit.
 */
export async function trackFunnelEvent(page, eventType, extraData = {}) {
  try {
    const body = {
      page,
      eventType,
      visitorId: getVisitorId(),
      sessionId: getSessionId(),
      referrer: document.referrer || null,
      userAgent: navigator.userAgent,
      language: navigator.language,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      ...extraData,
    };
    // fetch es más ligero que axios para fire-and-forget · y keepalive permite
    // que la petición sobreviva si el usuario navega justo después del click.
    await fetch(`${API}/analytics/visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch {
    // silencioso · analytics nunca bloquea UX
  }
}
